export function keepScroll() {
	return {
		deactivated(){
      this.$el.children[0].removeEventListener('scroll', this.handleScroll);
		},
		activated() {//后续进入
			if(this.scroll > 0){
        this.$el.children[0].scrollTo(0, this.scroll);
				this.scroll = 0;
        this.$el.children[0].addEventListener('scroll', this.handleScroll);
			}
		},
		mounted(){
      this.$el.children[0].addEventListener('scroll', this.handleScroll);
		},
		methods:{
			handleScroll () {
				let scrollTop = this.$el.children[0].scrollTop;
//				console.log(scrollTop)
				this.scroll = scrollTop;
			},
		}
	}
}